"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.createActionEvent = createActionEvent;
exports.logAction = logAction;

var _fluxStandardAction = require("flux-standard-action");

var _connectedReactRouter = require("connected-react-router");

var _uuid = require("uuid");

var _logBusinessEvent = require("../telemetry/logBusinessEvent");

var _logBusinessEventError = require("../telemetry/logBusinessEventError");

var _overrideSettings = require("../shared/override-settings/overrideSettings");

function createActionEvent(action) {
  var fsa = action;

  if (fsa.meta === undefined) {
    fsa.meta = {};
  }

  var correlationId = fsa.meta.correlationId;

  if (correlationId === undefined) {
    correlationId = fsa.meta.correlationId = (0, _uuid.v4)();
  }

  var operationName = action.type;
  var eventProperties = (0, _logBusinessEvent.createBusinessEvent)(operationName, '', correlationId);
  return eventProperties;
}

function logAction(action, telemetryProvider, eventProperties) {
  var customTelemetry = (0, _overrideSettings.getOverrideSetting)('telemetryImplementation');

  if (!(0, _fluxStandardAction.isError)(action)) {
    if (action.type === _connectedReactRouter.LOCATION_CHANGE) {
      var _locationChangeAction;

      var locationChangeAction = action;
      var path = ((_locationChangeAction = locationChangeAction.payload) === null || _locationChangeAction === void 0 ? void 0 : _locationChangeAction.location.pathname) || 'unknown';
      telemetryProvider.logPageView(path, path, undefined, telemetryProvider.initialLocation, telemetryProvider.referrer, eventProperties);
    } else {
      if (customTelemetry) {
        var _customTelemetry$log;

        (_customTelemetry$log = customTelemetry.log) === null || _customTelemetry$log === void 0 ? void 0 : _customTelemetry$log.call(customTelemetry, action.type, eventProperties);
      } else {
        telemetryProvider.logEvent(eventProperties);
      }
    }
  } else {
    var error = action.payload || new Error('Unknown error');
    var type = action.type;
    (0, _logBusinessEventError.logBusinessEventError)(type, error, eventProperties, telemetryProvider);
  }
}